/****************ELEMENTS*****************/
//this obj define, the actions realeted to each 
//th>table header and td
const math = require('../../../../../js-handler/math')

export const tableDetail = {
    entity: 'accountsReceivable',//name table on the db
    dest: 'accountsReceivable',//name of the entity on the system

    //action for body 
    //left click, directly to the fullcont 
    tdDataDetail: `data-detail='{ "click": [ {"dest":"ripple" },
                                            {"dest":"accountsReceivable", "elem":"fullcont", "id":"accountsReceivable-fullcont", "act":"callData", "dbid": "#dbid"}  ],
                                
                                 "clickRight": [{"dest":"accountsReceivable", "elem":"dt", "act":"trMenu", "id":"trMenu",  "entity":"report", "dbid": "#dbid" } ]  }'`,

    filter: {
        mainFilterFields: [""],
        mainFilterValues: ["", ""],
        andFilterFields: [""],
        andFilterValues: [""],
    }

}

/****************ELEMENTS*****************/

//each element could organize their data diferent
export function organizeRow(data) { //console.log('organizeRow>')

    var newData = []

    if (data.length === 0) {
        newData.push({
            id: 'nothing', colum: [{ label: 'No Results', span: '' },
            { label: '', span: '' },
            { label: '', span: '' },]
        })
        return newData
    }

    data.forEach((elem) => {
        newData.push(
            {
                id: elem.id, colum: [{
                    label: elem.customer,
                    span: elem.total_balance,
                    style: {
                        tdClass: "tdWithAvatar",
                        avatar: elem.avatar,
                        avatarColor: elem.avatarColor,
                        avatarColorLetter: elem.avatarColorLetter,
                        avatarLetter: elem.avatarLetter,
                    }
                },
                { label: elem.total_due_30_days, span:'' },
                { label: elem.total_due_31_to_60_days, span:'' },
                { label: elem.total_due_61_to_90_days, span:'' },
                { label: elem.total_due_over_90_days, span:'' },
                ]
            }
        )/*push*/
    })/*forEach*/

    return newData
}/*organizeRow*/